module.exports = "<p>\n  change-password works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/session/change-password/change-password.component.html
// module id = ../../../../../src/app/session/change-password/change-password.component.html
// module chunks = session.module